// extracted by mini-css-extract-plugin
module.exports = {"content":"ellipsis-text-tooltip_content__3NtmO","text":"ellipsis-text-tooltip_text__1o5I3"};